import ReactCalendar from 'react-calendar';

import moment from 'moment';

import { cn, ia } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import { formatShortWeekday } from '../lib/formatShortWeekday';

const CalendarComponent = (props) => {
  const {
    value,
    onChange,
    isPopover = false,
    isRange = false,
    isCompact = false,
    className,
    showWeekNumbers = false,
    selectWeekOnClick = false
  } = props;

  const isRanged = isRange || selectWeekOnClick;

  if (isRange && selectWeekOnClick)
    throw new Error('isRange and selectWeekOnClick should not be true at the same time.');

  const handleWeekClick = (date) => {
    if (!selectWeekOnClick || !onChange) return;
    const weekStart = moment(date).startOf('week');
    const weekEnd = moment(date).endOf('week');

    onChange([weekStart.toDate(), weekEnd.toDate()]);
  };

  return (
    <ReactCalendar
      selectRange={isRange}
      value={ia(value) ? (isRanged ? value : value[0]) : value}
      className={cn(
        className,
        isCompact && 'is-compact',
        isPopover && 'is-popover',
        selectWeekOnClick && 'is-week'
      )}
      onChange={!selectWeekOnClick && onChange}
      formatShortWeekday={formatShortWeekday}
      onClickDay={(value) => handleWeekClick(value)}
      showWeekNumbers={showWeekNumbers}
      onClickWeekNumber={(weekNumber, date) => handleWeekClick(date)}
      calendarType="gregory"
      prevLabel={<Icon icon="chevron-left-linear" size={16} />}
      nextLabel={<Icon icon="chevron-right-linear" size={16} />}
      prev2Label={null}
      next2Label={null}
    />
  );
};

export default CalendarComponent;
